import styled from 'styled-components';

import { Text } from '@atom/typography/typography';

export const Wrapper = styled.div`
  padding: 0 28px;
  margin-top: 32px;

  & .ant-breadcrumb-link {
    display: inline-flex;
    align-items: center;
  }
`;

export const PageLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 24px;
`;

export const PageLabel = styled(Text)<{ ml?: number }>`
  margin-left: ${(props) => props.ml ?? 4}px;
`;
